import { parseInboundPayload } from '../api/inbound/inbound';
import { numberParser } from '../api/inbound/inboundParsers';
import { splitWithBraces, trimBraces } from '../api/inbound/inboundUtils';
import { MAX_NUM_SEATS } from '../constants/constants';
import { cardStringParser } from './cardTypes';
import { ALL_BLINDS_LEVELS, ALL_CURRENCIES } from './sharedTypes';
export const ALL_SEAT_INDEXES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export function isSeatIndex(num) {
    return num !== undefined && num >= 0 && num < MAX_NUM_SEATS;
}
const ALL_TURN_STATES = ['waiting', 'bet', 'showdown']; // in order with respect to indexes present in inbounds
export const ALL_GAME_SPEEDS = ['slow', 'normal', 'fast', 'ludicrous']; // in order with respect to indexes present in inbounds
export const GAME_SPEED_LABELS = {
    slow: 'Slow',
    normal: 'Normal',
    fast: 'Fast',
    ludicrous: 'Ludicrous'
};
export const ALL_BET_POT_LABELS = ['BET', 'CALL', 'CHECK', 'FOLD', 'RAISE', 'ALL-IN', 'SMALL', 'BIG', 'POST'];
export const ALL_BET_POT_ACTION_LABELS = {
    bet: 'BET',
    call: 'CALL',
    check: 'CHECK',
    fold: 'FOLD',
    raise: 'RAISE',
    'all-in': 'ALL-IN',
    'small blind': 'SMALL',
    'big blind': 'BIG',
    post: 'POST'
};
export function turnStateOrdinalParser(str) {
    return ALL_TURN_STATES[Number(str)];
}
export function blindsIndexParser(str) {
    return ALL_BLINDS_LEVELS[Number(str)];
}
export function getGameSpeedIndex(gameSpeed) {
    return ALL_GAME_SPEEDS.indexOf(gameSpeed);
}
export function gameSpeedIndexParser(str) {
    return ALL_GAME_SPEEDS[Number(str)];
}
export function currencyIndexParser(str) {
    return ALL_CURRENCIES[Number(str)];
}
export function cardWithIndexParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, cardWithIndexPartDefinitions);
}
export function isDefaultShowdown(showdown) {
    // If the winning player has no ranked cards, this is a 'default' showdown.
    return showdown.winningCards[0].numRankedCards === 0;
}
const cardWithIndexPartDefinitions = [
    { name: 'cardIndex', parser: numberParser },
    { name: 'card', parser: cardStringParser }
];
export const ALL_CENTER_POT_LABELS = ['POT', 'MAIN', 'SIDE'];
